import { CustomizedDialog, CustomizedButton } from '@components/Customized';
import React from 'react';
import useStyles from './styles';
import { CompanyInfoEditPresenterProps } from './types';
import HowtoRegIcon from '@material-ui/icons/HowToReg';
import { Grid, InputLabel } from '@material-ui/core';
import { CapaErrorCode, CapaQuotationUserBizType } from '@generated/graphql';
import { InputItem } from '@components/Input/Inputs';
import useClient from '@hooks/useClient';

export default ({
  open,
  isIndividual,
  useHookForm,
  bizType,
  onClose,
  onSubmit,
  refetch
}: CompanyInfoEditPresenterProps) => {
  const classes = useStyles();
  const { clientState } = useClient();
  const { formState } = useHookForm;

  return (
    <CustomizedDialog
      color="primary"
      icon={<HowtoRegIcon />}
      open={open}
      onClose={onClose}
      closeButton
      title="회사정보 변경"
    >
      <form
        className={classes.form}
        onSubmit={useHookForm.handleSubmit(onSubmit)}
      >
        <Grid container>
          <InputLabel className={classes.inputLabel} required>
            회사명
          </InputLabel>
          <InputItem
            name="organizationName"
            errors={useHookForm.errors}
            inputProps={{
              placeholder: '회사명 *',
              ref: useHookForm.register({
                required: !isIndividual
              })
            }}
            marginBottom={12}
          />
        </Grid>

        {bizType === CapaQuotationUserBizType.Biz && (
          <Grid container>
            <InputLabel className={classes.inputLabel}>
              사업자등록번호
            </InputLabel>
            <InputItem
              name="companyRegistrationNumber"
              errors={useHookForm.errors}
              inputProps={{
                defaultValue: clientState.companyRegistrationNumber,
                placeholder: '-(하이픈) 제외하고 숫자만 입력',
                type: 'text',
                maxLength: 10,
                onChange: (e: any) =>
                  (e.currentTarget.value = e.currentTarget.value.trim()),
                ref: useHookForm.register({
                  required: false,
                  pattern: /^[0-9]*$/,
                  minLength: 10,
                  maxLength: 10,
                  validate: {
                    checkNumber: async (value) => {
                      if (!value) {
                        return true;
                      }
                      const { data, loading, error } = await refetch({
                        input: {
                          companyRegistrationNumber: value
                        }
                      });
                      const result =
                        data?.verifyCompanyRegistrationNumber?.result;
                      if (loading) return '조회중입니다';
                      if (error) return '사업자등록번호 조회에 실패했습니다.';
                      switch (result) {
                        case CapaErrorCode.Success:
                          return true;
                        case CapaErrorCode.DuplicateCompanyRegistrationNo:
                          return true;
                        case CapaErrorCode.InavlidCompanyRegistrationNo:
                          return '등록되지 않은 사업자등록번호 입니다.';
                        case CapaErrorCode.ParmeterValidationError:
                          return '잘못된 형식입니다.';
                        default:
                          return '사업자등록번호 조회에 실패했습니다.';
                      }
                    }
                  }
                })
              }}
              marginBottom={12}
            />
          </Grid>
        )}
        <CustomizedButton
          className={classes.submitButton}
          type="submit"
          variant="contained"
          color="primary"
          disabled={!formState.isValid}
        >
          변경하기
        </CustomizedButton>
      </form>
    </CustomizedDialog>
  );
};
